import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['../../app.component.css', './footer.component.css'],
})

export class FooterComponent {

}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts